var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconApartmentPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2337 18H8.45595C8.04339 18 7.64773 17.8361 7.356 17.5444C7.06428 17.2527 6.90039 16.857 6.90039 16.4444V6.53505C6.90039 6.12249 7.06428 5.72683 7.356 5.4351C7.64773 5.14338 8.04339 4.97949 8.45595 4.97949H13.9004L17.7893 8.86838V16.4444C17.7893 16.857 17.6254 17.2527 17.3337 17.5444C17.0419 17.8361 16.6463 18 16.2337 18Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3447 13.6686L12.3008 9.5",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4004 11.7241L12.3448 13.6686L14.2893 11.7241",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApartmentPdf);
export default __webpack_public_path__ + "static/media/icon_apartment_pdf.fd65e173f880f15dd5c2edb988bf5dc7.svg";
export { ForwardRef as ReactComponent };